import React from "react";
import classes from './generalModal.module.scss';
import { useAuth0 } from "@auth0/auth0-react";

const GeneralModal = (props: any) => {
    const { message, keyword, setGeneralModal, SendEmail, setShow } = props;
    const { logout, } = useAuth0();
    const handleClose = () => {
        setGeneralModal('false')
        if (message === "You will receive password reset instructions via email") {
            setShow(false)
        }
    }
    return <div className={classes.ModalMain}>
        <div className={classes.ModalMainArea}>
            <div className={classes.ModalMessage}>
                {message}
            </div>
            <div className={classes.Buttonset}>
                <button className={keyword === 'Save' || keyword === 'Remove' ? classes.Close : classes.onlyClose} onClick={() => { handleClose() }}>Close</button>
                <button className={keyword === 'Save' ? classes.Save : classes.noSave} onClick={() => { logout({ returnTo: window.location.origin + '/viewer/' }); localStorage.clear() }}> Sign Out</button>
                <button className={keyword === 'Remove' ? classes.Save : classes.noSave} onClick={() => SendEmail()}>Yes Send</button>
            </div>
        </div>
    </div>
}

export default GeneralModal